import { motion } from 'framer-motion'
import { Input, Textarea } from '@/components/ui/Input'
import type { Plan } from '@/components/Configuracao/plansTabTypes'
import { resolvePlanTypeForCategory } from '@/components/Configuracao/plansTabUtils'

type Props = {
  plan: Plan
  onPlanChange: (plan: Plan) => void
}

export function PlansTabModalInfoTab({ plan, onPlanChange }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.15 }}
      className="grid grid-cols-1 md:grid-cols-3 gap-4"
    >
      <Input
        label="Nome do Plano"
        required
        value={plan.name || ''}
        onChange={(e) => onPlanChange({ ...plan, name: e.target.value })}
        placeholder="Ex: Start, Evolve..."
      />
      <Input
        label="Categoria"
        value={plan.category || ''}
        onChange={(e) => {
          const category = e.target.value
          onPlanChange({
            ...plan,
            category,
            type: resolvePlanTypeForCategory(category, plan.type),
          })
        }}
        placeholder="Ex: Marketing, Desenvolvimento"
      />
      <div className="flex flex-col gap-1.5">
        <label
          className="font-medium text-[var(--font-color-label)] uppercase tracking-wider"
          style={{ fontSize: 'var(--font-size-label)' }}
        >
          Tipo de Plano
        </label>
        <select
          required
          value={resolvePlanTypeForCategory(plan.category, plan.type)}
          onChange={(e) =>
            onPlanChange({
              ...plan,
              type: e.target.value as Plan['type'],
            })
          }
          className="w-full min-h-[44px] bg-[var(--bg-card)] border border-[var(--glass-border)] text-[var(--text-primary)] rounded-md px-3 py-2 outline-none text-[13px] transition-colors focus:border-[var(--brand-primary)] focus:ring-1 focus:ring-[var(--brand-primary-muted)] cursor-pointer"
        >
          <option value="RECORRENTE" className="bg-[var(--bg-card)] text-[var(--text-primary)]">
            Recorrente
          </option>
          <option value="PACOTE_HORAS" className="bg-[var(--bg-card)] text-[var(--text-primary)]">
            Pacote de Horas
          </option>
          <option value="DEMANDAS_ESPECIFICAS" className="bg-[var(--bg-card)] text-[var(--text-primary)]">
            Demandas Específicas
          </option>
        </select>
      </div>
      <div className="md:col-span-3">
        <Textarea
          label="Breve Descrição / Contrato SLA"
          rows={2}
          value={plan.description || ''}
          onChange={(e) => onPlanChange({ ...plan, description: e.target.value })}
        />
      </div>
    </motion.div>
  )
}
